import React from "react";
import { classNames } from "Utils/utils";
import { isCareWatchLiveView } from "../utils/constants";
import CareWatchTable from "./CareWatchTable";
import CareWatchDetailDock from "./CareWatchDetailDock";
import {
  CareWatchDetailSkeleton,
  CareWatchTableSkeleton,
} from "./CareWatchSkeletons";

const CareWatchWorkArea = ({
  view,
  loading = false,
  tableLoading = false,
  detailLoading = false,
  pageItems,
  selectedId,
  selected,
  detailSlotClass,
  promoteHighlight,
  promoteLoading,
  acknowledgeLoading,
  page,
  totalPages,
  total,
  pageSize,
  categoryCaption,
  toggleRow,
  toggleChecked,
  setPage,
  setPageSize,
  onAcknowledge,
  onPromote,
  onReanalyse,
  reanalyseLoading = false,
  onCloseDetail,
  onChangeRisk,
  riskSavingId,
}) => {
  const isLive = isCareWatchLiveView(view);
  return (
    <div
      className={classNames("care-watch-work", isLive && "care-watch-work--live")}
    >
    {loading || tableLoading ? (
      <CareWatchTableSkeleton view={view} />
    ) : (
      <CareWatchTable
        view={view}
        rows={pageItems}
        selectedId={isLive ? null : selectedId}
        onSelectRow={isLive ? undefined : toggleRow}
        onToggleChecked={isLive ? undefined : toggleChecked}
        onChangeRisk={onChangeRisk}
        riskSavingId={riskSavingId}
        page={page}
        totalPages={totalPages}
        total={total}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        matchCaption={categoryCaption}
      />
    )}
    <div
      className={detailSlotClass}
      hidden={isLive}
      aria-hidden={isLive}
      data-scroll-lock-allow
    >
      {loading ? (
        <CareWatchDetailSkeleton view={view} />
      ) : (
        <CareWatchDetailDock
          item={selected}
          view={view}
          detailLoading={detailLoading}
          promoteHighlight={promoteHighlight}
          promoteLoading={promoteLoading}
          acknowledgeLoading={acknowledgeLoading}
          onAcknowledge={onAcknowledge}
          onPromote={onPromote}
          onReanalyse={onReanalyse}
          reanalyseLoading={reanalyseLoading}
          onClose={onCloseDetail}
        />
      )}
    </div>
  </div>
  );
};

export default CareWatchWorkArea;
